/* eslint-disable jsx-a11y/anchor-is-valid */
import {useFormik} from 'formik'
import {FC, useEffect, useState} from 'react'
import * as Yup from 'yup'
import {isEmpty, isNotEmpty} from '../../../../../_metronic/helpers'
import {scrollToFieldError} from '../../../../utils/view'
import {useListView} from '../core/ListViewProvider'
import {useQueryResponse} from '../core/QueryResponseProvider'
import {useLocation} from 'react-router-dom'
import {useAuth, MenuModel, getMenuAccess} from '../../../auth'
import {JudolListLoading} from '../components/loading/JudolListLoading'
import {
  initialJudol,
  initialReporter,
  Judol,
  Reported,
  Reporter,
  ReportEvidence,
  ReportJudolUrl,
  Suspect,
} from '../core/_models'
import {createJudol, rejectJudol, updateJudol, verifyJudol} from '../core/_requests'
import clsx from 'clsx'
import DatePicker from '../../../../components/DatePicker'
import CriminalOffenceSelect from '../../../criminalOffences/components/CriminalOffenceSelect'
import ItemUnitsSelect from '../../../itemUnits/components/ItemUnitsSelect'
import {ItemUnit} from '../../../itemUnits/core/_model'
import EvidenceSelect from '../../../evidence/components/EvidenceSelect'
import CaseStatusSelect from '../../../case-status/components/CaseStatusSelect'
import {
  ModusOperandiSelect,
  NoFormModusOperandiSelect,
} from '../../../modus-operandi/components/ModusOperandiSelect'
import {ReportAmplificationForm} from '../../../amplification/components/ReportAmplificationForm'
import moment from 'moment'
import {Accordion} from 'react-bootstrap'
import {NoFormGenderSelect} from '../../../gender/components/GenderSelect'
import ReportReported from '../../../../components/ReportReported'
import ReportSuspect from '../../../../components/ReportSuspect'
import SubSatgasEnum from '../../../../enums/SubSatgasEnum'
import ReportEvidenceForm from '../../../../components/ReportEvidence'
import {rejectJudi, verifyJudi} from '../../../judi/judi-list/core/_requests'
import {Confirm} from '../../../../components/Confirm'
import {showError} from '../../../../utils/toast'

type props = {
  judol: Judol
  isLoading: boolean
}

let yupValidation = {
  // policeReportNo: Yup.string().required('Nomor laporan polisi wajib diisi'),
  // policeReportDate: Yup.string().required('Tanggal laporan polisi wajib diisi'),
  // reportDate: Yup.string().required('Tanggal laporan wajib diisi'),
  // crimeScene: Yup.string().required('Tempat kejadian wajib diisi'),
  // crimeTime: Yup.string().required('Waktu kejadian wajib diisi'),
  // chronology: Yup.string().required('Kronologi wajib diisi'),
  // attentionDesc: Yup.string().max(1024, 'Maksimal 1024 karakter'),
  // caseStatusId: Yup.number().required('Status Kasus wajib dipilih'),
}

const addJudolSchema = Yup.object().shape({
  ...yupValidation,
})
const editJudolSchema = Yup.object().shape({
  ...yupValidation,
})

const JudolEditModalForm: FC<props> = ({judol, isLoading}) => {
  const {setItemIdForUpdate} = useListView()
  const {refetch} = useQueryResponse()
  const {pathname} = useLocation()
  const {currentMenu} = useAuth()
  const [menuAccess, setMenuAccess] = useState<MenuModel | undefined>(undefined)

  const [showVerifyConfirmation, setShowVerifyConfirmation] = useState(false)
  const [showRejectConfirmation, setShowRejectConfirmation] = useState(false)
  const [isVerify, setIsVerify] = useState(false)
  const [isReject, setIsReject] = useState(false)

  const [reporterForm, setReporterForm] = useState<Reporter>({...initialReporter})

  const [reported, setReported] = useState<Reported[]>([])
  const [isEditReported, setEditReported] = useState<boolean>(false)

  const [suspects, setSuspect] = useState<Suspect[]>([])
  const [suspectForm, setSuspectForm] = useState<Suspect>({})
  const [isEditSuspect, setEditSuspect] = useState<boolean>(false)

  const [evidences, setEvidences] = useState<ReportEvidence[]>([])
  const [evidenceForm, setEvidenceForm] = useState<ReportEvidence>({})
  const [isEditEvidence, setEditEvidence] = useState<boolean>(false)

  const [links, setLink] = useState<ReportJudolUrl[]>([])
  const [linkForm, setLinkForm] = useState<ReportJudolUrl>({})
  const [isEditLink, setEditLink] = useState<boolean>(false)
  const [itemUnit, setItemUnit] = useState<ItemUnit | undefined>()
  const [amplifications, setAmplifications] = useState<any[]>([])
  const [isSubmit, setIsSubmit] = useState(true)
  const [tabActive, setTabActive] = useState(0)
  const [dynamicValidation, setDynamicValidation] = useState<any>(Yup.object().shape({}))
  const [isValidationUpdated, setIsValidationUpdated] = useState(false)
  const [isNext, setIsNext] = useState(true)
  const [tabs, setTabs] = useState([
    {
      id: '#report',
      label: 'Laporan',
      isRequired: true,
    },
    {
      id: '#detail',
      label: 'Detail',
      isRequired: false,
    },
    {
      id: '#evidence',
      label: 'Barang Bukti',
      isRequired: true,
    },
    {
      id: '#linkweb',
      label: 'Link Web',
      isRequired: true,
    },
    {
      id: '#reporter',
      label: 'Data Pelapor',
      isRequired: false,
    },
    {
      id: '#suspect',
      label: 'Data Tersangka',
      isRequired: false,
    },
  ])
  const linkWebIndex = 3
  const suspectIndex = 5

  const [data, setData] = useState<Judol>({
    ...judol,
    id: judol.id || initialJudol.id,
    policeReportNo: judol.policeReportNo || initialJudol.policeReportNo,
    policeReportDate: judol.policeReportDate || initialJudol.policeReportDate,
    caseStatusId: judol.caseStatusId || initialJudol.caseStatusId,
    crimeScene: judol.crimeScene || initialJudol.crimeScene,
    crimeTime: judol.crimeTime || initialJudol.crimeTime,
    chronology: judol.chronology || initialJudol.chronology,
    caseStatusName: judol.caseStatusName || initialJudol.caseStatusName,
    attentionLevel: judol.attentionLevel || 1,
    attentionDesc: judol.attentionDesc || initialJudol.attentionDesc,
    suspectRequired: judol.suspectRequired || false,
    reportDate: judol.reportDate || moment().startOf('days').toDate().toISOString(),
  })

  useEffect(() => {
    if (!isLoading) {
      setData({
        ...judol,
        id: judol.id || initialJudol.id,
        policeReportNo: judol.policeReportNo || initialJudol.policeReportNo,
        policeReportDate: judol.policeReportDate || initialJudol.policeReportDate,
        caseStatusId: judol.caseStatusId || initialJudol.caseStatusId,
        crimeScene: judol.crimeScene || initialJudol.crimeScene,
        crimeTime: judol.crimeTime || initialJudol.crimeTime,
        chronology: judol.chronology || initialJudol.chronology,
        caseStatusName: judol.caseStatusName || initialJudol.caseStatusName,
        attentionLevel: judol.attentionLevel || 1,
        attentionDesc: judol.attentionDesc || initialJudol.attentionDesc,
        suspectRequired: judol.suspectRequired || false,
        reportDate: judol.reportDate || moment().startOf('days').toDate().toISOString(),
      })

      setSuspect(judol.suspects)
      setReported(judol.reporteds)
      setReporterForm({
        ...initialReporter,
        name: judol.reporters[0]?.name || initialReporter.name,
        nik: judol.reporters[0]?.nik || initialReporter.nik,
        address: judol.reporters[0]?.address || initialReporter.address,
        gender: judol.reporters[0]?.gender || initialReporter.gender,
        dob: judol.reporters[0]?.dob || initialReporter.dob,
        pob: judol.reporters[0]?.pob || initialReporter.pob,
      })
      setEvidences(judol.evidences)
      setLink(judol.urls)

      if (judol.amplifications && judol.amplifications.length > 0) {
        setAmplifications(judol.amplifications)
      }

      // if (!judol.reportDate) {
      //   formik.setFieldValue('reportDate', moment().format('yyyy-MM-DD'))
      // }
      updateRequiredTab(judol.suspectRequired ?? false)
    }
  }, [judol, isLoading])

  useEffect(() => {
    console.log('data', linkForm)
  }, [linkForm])

  const updateRequiredTab = (val: boolean) => {
    setTabs((prev) =>
      prev.map((item, index) => (index === suspectIndex ? {...item, isRequired: val} : item))
    )
  }

  const isSuspectRequired = () => {
    return tabs[3].isRequired
  }

  const addNewLink = (item: ReportJudolUrl) => {
    if (isEditLink) {
      const idx = links.findIndex((q) => q.key === item.key)

      if (idx >= 0) {
        setLink([...links.filter((_, i) => i !== idx), item])
        setEditLink(false)
      }
      return
    }

    setLink([...links, item])
  }

  const addNewReported = (item: Reported) => {
    if (isEditReported) {
      const idx = reported.findIndex((q) => q.key === item.key)

      if (idx >= 0) {
        setReported([...reported.filter((_, i) => i !== idx), item])
        setEditReported(false)
      }
      return
    }

    setReported([...reported, item])
  }

  const addNewSuspect = (item: Suspect) => {
    if (isEditSuspect) {
      const idx = suspects.findIndex((q) => q.key === item.key)

      if (idx >= 0) {
        setSuspect([...suspects.filter((_, i) => i !== idx), item])
        setEditSuspect(false)
      }
      return
    }

    setSuspect([...suspects, item])
  }

  const addNewReportEvidence = (item: ReportEvidence) => {
    if (isEditEvidence) {
      const idx = evidences.findIndex((q) => q.key === item.key)

      if (idx >= 0) {
        setEvidences([...evidences.filter((_, i) => i !== idx), item])
        setEditEvidence(false)
      }
      return
    }

    setEvidences([...evidences, item])
  }

  useEffect(() => {
    setMenuAccess(getMenuAccess(currentMenu ?? [], pathname))
  }, [currentMenu])

  const cancel = (withRefresh?: boolean) => {
    if (withRefresh) {
      refetch()
    }
    setItemIdForUpdate(undefined)
  }

  const saveDraft = (_isNext = true) => {
    setIsNext(_isNext)
    setIsSubmit(false)
    setDynamicValidation(getValidation(false))
    setIsValidationUpdated(true)
    // formik.handleSubmit()
  }

  useEffect(() => {
    if (isValidationUpdated) {
      formik.handleSubmit()
      setIsValidationUpdated(false)
    }
  }, [isValidationUpdated])

  const getValidation = (isSubmit = true) => {
    let yupValidation = {}
    if (isSubmit) {
      yupValidation = {
        policeReportNo: Yup.string()
          .max(1024, 'Maksimal 1024 karakter')
          .required('Nomor laporan polisi wajib diisi'),
        policeReportDate: Yup.string().required('Tanggal laporan polisi wajib diisi'),
        reportDate: Yup.string().required('Tanggal laporan wajib diisi'),
        crimeScene: Yup.string()
          .max(2048, 'Maksimal 2048 karakter')
          .required('Tempat kejadian wajib diisi'),
        crimeTime: Yup.string().required('Waktu kejadian wajib diisi'),
        caseStatusId: Yup.string().required('Status Kasus wajib diisi'),
        chronology: Yup.string().max(4096, 'Maksimal 4096 karakter'),
        attentionDesc: Yup.string().max(2048, 'Maksimal 2048 karakter').notRequired(),
      }
    } else {
      yupValidation = {
        policeReportNo: Yup.string()
          .max(1024, 'Maksimal 1024 karakter')
          .required('Nomor laporan polisi wajib diisi'),
        reportDate: Yup.string().required('Tanggal laporan wajib diisi'),
        caseStatusId: Yup.string().required('Status Kasus wajib diisi'),
        attentionDesc: Yup.string().max(2048, 'Maksimal 2048 karakter').notRequired(),
        crimeScene: Yup.string().max(2048, 'Maksimal 2048 karakter'),
        chronology: Yup.string().max(4096, 'Maksimal 4096 karakter'),
      }
    }

    return Yup.object().shape({
      ...yupValidation,
    })
  }

  const formik = useFormik({
    initialValues: data,
    validationSchema: dynamicValidation,
    enableReinitialize: true,
    onSubmit: async (values, {setSubmitting, setStatus}) => {
      if (isSubmit) {
        if (evidences.length === 0) {
          showError('Barang bukti wajib diisi (minimal 1)')
          setTabActive(2)
          return
        }

        if (links.length === 0) {
          showError('Link web wajib diisi (minimal 1)')
          setTabActive(linkWebIndex)
          return
        }

        if (isSuspectRequired() && suspects.length === 0) {
          showError('Data tersangka wajib diisi (minimal 1)')
          setTabActive(suspectIndex)
          return
        }
      }

      setStatus(null)
      setSubmitting(true)

      if (isVerify) {
        setIsVerify(false)
        await verifyJudol(judol.id)
        setSubmitting(false)
        cancel(true)
        return
      }

      if (isReject) {
        setIsReject(false)
        await rejectJudol(judol.id)
        setSubmitting(false)
        cancel(true)
        return
      }

      if (isNotEmpty(judol.id)) {
        values.evidences = evidences
        values.reporteds = reported

        if (!isEmpty(reporterForm)) {
          values.reporters = [reporterForm]
        }

        values.suspects = suspects
        values.urls = links
      }
      try {
        if (isNotEmpty(judol.id)) {
          values.isSubmit = isSubmit
          setIsSubmit(true)

          await updateJudol(values)
        } else {
          setIsSubmit(true)
          const result = await createJudol(values)
          if (result?.id) {
            setItemIdForUpdate(result.id)
            refetch()
          }
        }
        setSubmitting(false)
        if ((values.isSubmit || tabActive === tabs.length - 1) && isNext) {
          cancel(true)
        } else {
          setTabActive((prev) => prev + (isNext ? 1 : -1))
        }
      } catch (ex: any) {
        console.error(ex)
        showError(ex.message)
      }
    },
  })

  useEffect(() => {
    if (!formik.isValid && formik.submitCount !== 0 && isValidationUpdated) {
      scrollToFieldError()
    }
  }, [formik.submitCount, formik.isValid, formik.errors, isValidationUpdated])

  const [isTerlaporTersangka, setIsTerlaporTersangka] = useState(false)

  const handleCheckboxChange = (e) => {
    setIsTerlaporTersangka(e.target.checked)
    if (e.target.checked) {
      setSuspect(reported)
    } else {
      setSuspect([])
    }
  }

  /* BEGIN:VERIFY */

  const handleCloseVerifyConfirmation = () => setShowVerifyConfirmation(false)
  const handleConfirmVerify = async () => {
    setIsVerify(true)
    handleCloseVerifyConfirmation()
    formik.handleSubmit()
  }

  const handleOpenVerifyConfirmation = () => {
    setShowVerifyConfirmation(true)
  }

  /* END:VERIFY */

  /* BEGIN:REJECT */

  const handleCloseRejectConfirmation = () => setShowRejectConfirmation(false)
  const handleConfirmReject = async () => {
    setIsReject(true)
    handleCloseRejectConfirmation()
    formik.handleSubmit()
  }

  const handleOpenRejectConfirmation = () => {
    setShowRejectConfirmation(true)
  }

  /* END:REJECT */

  return (
    <>
      <form
        className={clsx('p-3', {'readonly-form': judol.button?.allowEdit === false})}
        onSubmit={(e) => {
          e.preventDefault()
          setDynamicValidation(getValidation(true))
          setIsValidationUpdated(true)
        }}
      >
        <div className='form-tab-container'>
          <ul className='nav nav-pills'>
            {tabs.map((m, i) => {
              if (!isNotEmpty(judol.id) && i > 0) {
                return null
              }
              return (
                <li key={i} className='nav-item' onClick={() => setTabActive(i)}>
                  <a
                    className={`nav-link ${tabActive === i && 'active'}`}
                    aria-current='page'
                    href='#'
                  >
                    {m.label} {m.isRequired && <span className='text-danger'>*</span>}
                  </a>
                </li>
              )
            })}
          </ul>
        </div>

        {/*<fieldset disabled={!menuAccess?.canCreate || isLoading}>*/}
          <div>
            {formik.status ? (
              <div className='mb-lg-5 alert alert-danger'>
                <div className='alert-text font-weight-bold'>{formik.status}</div>
              </div>
            ) : (
              ''
            )}

            <div className='modal-tab-content tab-content'>
              <div
                className={`tab-pane ${tabActive === 0 && 'fade show active'}`}
                id='report'
                role='tabpanel'
                aria-labelledby='report-tab'
              >
                <div className='tab-inner'>
                  <div className='container-fluid'>
                    <label className='form-section-title'>
                      <i className='fa-regular fa-file-lines'></i> Data Laporan
                    </label>

                    <div className='row mb-3'>
                      <div className='fv-row d-flex flex-column mb-7 col-6'>
                        <label className='required form-label'>Tanggal Pelaporan</label>
                        <DatePicker
                          label='Select Date'
                          field={formik.getFieldProps('reportDate')}
                          form={formik}
                          labelFormat='d/m/Y'
                          {...formik.getFieldProps('reportDate')}
                          disabled={judol.button?.allowEdit === false}
                        />
                        {formik.touched.reportDate && formik.errors.reportDate && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{formik.errors.reportDate}</span>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className='mb-3 col-md-6'>
                        <label htmlFor='location' className='form-label required'>
                          Status Kasus
                        </label>
                        <CaseStatusSelect
                          form={formik}
                          field={formik.getFieldProps('caseStatusId')}
                          disabled={judol.button?.allowEdit === false}
                          initialOptions={
                            judol && judol.caseStatusName
                              ? [
                                  {
                                    value: judol.caseStatusId,
                                    label: judol.caseStatusName,
                                  },
                                ]
                              : []
                          }
                          onChange={(e) => {
                            updateRequiredTab(e.suspectRequired ?? false)
                          }}
                        />
                        {formik.touched.caseStatusId && formik.errors.caseStatusId && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{formik.errors.caseStatusId}</span>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className='col-md-6'>
                        <label htmlFor='reportNumber' className='form-label required'>
                          Nomor Laporan Polisi
                        </label>
                        <input
                          placeholder='LP/XXX/XX/2024/...'
                          {...formik.getFieldProps('policeReportNo')}
                          type='text'
                          name='policeReportNo'
                          className={clsx(
                            'form-control mb-3 mb-lg-0',
                            {
                              'is-invalid':
                                formik.touched.policeReportNo && formik.errors.policeReportNo,
                            },
                            {
                              'is-valid':
                                formik.touched.policeReportNo && !formik.errors.policeReportNo,
                            }
                          )}
                          autoComplete='off'
                          disabled={
                            formik.isSubmitting || isLoading || judol.button?.allowEdit === false
                          }
                        />
                        {formik.touched.policeReportNo && formik.errors.policeReportNo && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{formik.errors.policeReportNo}</span>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className='col-md-6'>
                        <div className='fv-row d-flex flex-column mb-7'>
                          <label className='required form-label'>Tanggal Laporan Polisi</label>
                          <DatePicker
                            label='Select Date'
                            field={formik.getFieldProps('policeReportDate')}
                            form={formik}
                            {...formik.getFieldProps('policeReportDate')}
                            disabled={judol.button?.allowEdit === false}
                          />
                          {formik.touched.policeReportDate && formik.errors.policeReportDate && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>
                                <span role='alert'>{formik.errors.policeReportDate}</span>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <label className='form-section-title'>
                      <i className='fa-solid fa-location-dot'></i> Lokasi Kejadian
                    </label>

                    <div className='row'>
                      <div className='mb-3 col-md-12'>
                        <label htmlFor='location' className='form-label required'>
                          Alamat Lengkap
                        </label>
                        <textarea
                          id='location'
                          className={clsx(
                            'form-control',
                            {
                              'is-invalid': formik.touched.crimeScene && formik.errors.crimeScene,
                            },
                            {
                              'is-valid': formik.touched.crimeScene && !formik.errors.crimeScene,
                            }
                          )}
                          rows={3}
                          placeholder='Masukkan alamat lengkap lokasi kejadian...'
                          {...formik.getFieldProps('crimeScene')}
                          disabled={judol.button?.allowEdit === false}
                        ></textarea>
                        {formik.touched.crimeScene && formik.errors.crimeScene && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{formik.errors.crimeScene}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <label className='form-section-title'>
                      <i className='fa-regular fa-clock'></i> Waktu Kejadian
                    </label>

                    <div className='row'>
                      <div className='fv-row d-flex flex-column mb-7 col-md-6'>
                        <label className='required form-label'>Waktu Kejadian</label>
                        <DatePicker
                          label='Select Date'
                          field={formik.getFieldProps('crimeTime')}
                          {...formik.getFieldProps('crimeTime')}
                          form={formik}
                          enableTime={true}
                          labelFormat='d/m/Y H:i'
                          disabled={judol.button?.allowEdit === false}
                        />
                        {formik.touched.crimeTime && formik.errors.crimeTime && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{formik.errors.crimeTime}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <label className='form-section-title'>
                      <i className='fa-solid fa-triangle-exclamation'></i> Atensi
                    </label>

                    <div className='row'>
                      <div className='mb-3 col-md-6'>
                        <div className='fv-row d-flex flex-column mb-7'>
                          <label className='form-label required'>Level</label>
                          <div className='form-check-inline mt-3'>
                            <div className='form-check form-check-inline'>
                              <input
                                className='form-check-input'
                                type='radio'
                                name='inlineRadioOptions'
                                id='attentionLevel1'
                                value='1'
                                checked={formik.values.attentionLevel === 1}
                                onChange={(e) => formik.setFieldValue('attentionLevel', 1)}
                                disabled={judol.button?.allowEdit === false}
                              />
                              <label htmlFor='attentionLevel1'>Biasa</label>
                            </div>
                            <div className='form-check form-check-inline'>
                              <input
                                className='form-check-input'
                                type='radio'
                                name='inlineRadioOptions'
                                id='attentionLevel2'
                                value='2'
                                checked={formik.values.attentionLevel === 2}
                                onChange={(e) => formik.setFieldValue('attentionLevel', 2)}
                                disabled={judol.button?.allowEdit === false}
                              />
                              <label htmlFor='attentionLevel2'>Viral</label>
                            </div>
                            <div className='form-check form-check-inline'>
                              <input
                                className='form-check-input'
                                type='radio'
                                name='inlineRadioOptions'
                                id='attentionLevel3'
                                value='3'
                                checked={formik.values.attentionLevel === 3}
                                onChange={(e) => formik.setFieldValue('attentionLevel', 3)}
                                disabled={judol.button?.allowEdit === false}
                              />
                              <label htmlFor='attentionLevel3'>Sangat Viral</label>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className='mb-3 col-12'>
                        <div className='fv-row d-flex flex-column mb-7'>
                          <label className='form-label'>Deskripsi</label>
                          <textarea
                            className={clsx(
                              'form-control',
                              {
                                'is-invalid':
                                  formik.touched.attentionDesc && formik.errors.attentionDesc,
                              },
                              {
                                'is-valid':
                                  formik.touched.attentionDesc && !formik.errors.attentionDesc,
                              }
                            )}
                            rows={3}
                            {...formik.getFieldProps('attentionDesc')}
                            disabled={judol.button?.allowEdit === false}
                          ></textarea>
                          {formik.touched.attentionDesc && formik.errors.attentionDesc && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>
                                <span role='alert'>{formik.errors.attentionDesc}</span>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={`tab-pane ${tabActive === 1 && 'fade show active'}`}
                id='detail'
                role='tabpanel'
                aria-labelledby='report-detail'
              >
                <div className='tab-inner'>
                  <div className='container-fluid'>
                    <label className='form-section-title'>
                      <i className='fa-regular fa-square-minus'></i> Modus Operandi
                    </label>

                    <div className='row'>
                      <div className='mb-3 col-md-6'>
                        <label htmlFor='chronology' className='form-label'>
                          Jenis Perjudian
                        </label>
                        <ModusOperandiSelect
                          isClearable={false}
                          isMulti={true}
                          initialOptions={
                            judol.modusOperandi && judol.modusOperandi.length > 0
                              ? judol.modusOperandi.map((e) => {
                                  return {
                                    value: e.modusOperandiId,
                                    name: e.modusOperandiName,
                                  }
                                })
                              : []
                          }
                          className='menu-outer-top'
                          form={formik}
                          disabled={!menuAccess?.canCreate || judol.button?.allowEdit === false}
                          field={formik.getFieldProps('modusOperandi')}
                          subSatgasId={SubSatgasEnum.GAKKUMJUDOL}
                        />
                      </div>
                      <div className='mb-3 col-md-6'>
                        <label htmlFor='chronology' className='form-label'>
                          Pasal
                        </label>
                        <CriminalOffenceSelect
                          isClearable={false}
                          isMulti={true}
                          initialOptions={
                            judol.criminalOffences && judol.criminalOffences.length > 0
                              ? judol.criminalOffences.map((e) => {
                                  return {
                                    value: e.criminalOffenceId,
                                    // @ts-ignore
                                    label: e.criminalOffenceName,
                                  }
                                })
                              : []
                          }
                          className='menu-outer-top'
                          field={formik.getFieldProps('criminalOffences')}
                          form={formik}
                          disabled={!menuAccess?.canCreate || judol.button?.allowEdit === false}
                        />
                      </div>
                    </div>

                    <div className='row'>
                      <div className='mb-3 col-md-12'>
                        <label htmlFor='chronology' className='form-label'>
                          Kronologi
                        </label>
                        <textarea
                          id='chronology'
                          className={clsx(
                            'form-control',
                            {
                              'is-invalid': formik.touched.chronology && formik.errors.chronology,
                            },
                            {
                              'is-valid': formik.touched.chronology && !formik.errors.chronology,
                            }
                          )}
                          rows={10}
                          placeholder='Detailkan kronologi'
                          {...formik.getFieldProps('chronology')}
                          disabled={judol.button?.allowEdit === false}
                        ></textarea>
                        {formik.touched.chronology && formik.errors.chronology && (
                          <div className='fv-plugins-message-container'>
                            <div className='fv-help-block'>
                              <span role='alert'>{formik.errors.chronology}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={`tab-pane ${tabActive === 2 && 'fade show active'}`}
                id='evidence'
                role='tabpanel'
                aria-labelledby='report-evidence'
              >
                <div className='tab-inner'>
                  <ReportEvidenceForm
                    useAccordion={false}
                    evidences={evidences}
                    isEditEvidence={isEditEvidence}
                    isLoading={isLoading}
                    setEditEvidence={setEditEvidence}
                    setEvidence={setEvidences}
                    disabled={judol.button?.allowEdit === false}
                    resetValidation={tabActive === 2}
                  />{' '}
                </div>
              </div>

              <div
                className={`tab-pane ${tabActive === 3 && 'fade show active'}`}
                id='linkweb'
                role='tabpanel'
                aria-labelledby='report-linkweb'
              >
                <div className='tab-inner'>
                  <div>
                    {judol.button?.allowEdit && (
                      <>
                        <label className='form-section-title'>
                          <i className='fa-regular fa-file-lines'></i> Form Link Web
                        </label>
                        <div className='row mb-2'>
                          <div className='col-md-6 mb-3'>
                            <input type='hidden' value={linkForm.id} />
                            <label htmlFor='report_evidence' className='form-label required'>
                              Judul
                            </label>
                            <input
                              type='text'
                              id='title-judol'
                              className='form-control'
                              placeholder='Masukkan Judul'
                              value={linkForm.title}
                              onChange={(e) => setLinkForm({...linkForm, title: e.target.value})}
                              // disabled={judol.button?.allowEdit === false}
                            />
                          </div>
                          <div className='col-md-6'>
                            <label htmlFor='satuan' className='form-label'>
                              URL
                            </label>
                            <input
                              type='text'
                              className='form-control'
                              placeholder='Masukkan URL'
                              value={linkForm.url}
                              onChange={(e) => setLinkForm({...linkForm, url: e.target.value})}
                              // disabled={judol.button?.allowEdit === false}
                            />
                          </div>
                        </div>
                        <div className='row'>
                          <div className='col-md-12'>
                            <label className='form-label'>Deskripsi</label>
                            <textarea
                              rows={3}
                              className='form-control'
                              value={linkForm.description}
                              onChange={(e) =>
                                setLinkForm({...linkForm, description: e.target.value})
                              }
                              // disabled={judol.button?.allowEdit === false}
                            ></textarea>
                          </div>
                        </div>
                        <div className='mt-3 d-flex justify-content-center'>
                          {isEditLink && (
                            <button
                              className='btn btn-sm btn-outline btn-outline-danger me-3'
                              onClick={(e) => {
                                e.preventDefault()
                                e.stopPropagation()
                                setLinkForm({
                                  key: '',
                                  description: '',
                                  title: '',
                                  url: '',
                                })
                                setEditLink(false)
                              }}
                            >
                              Batal
                            </button>
                          )}

                          <button
                            className='btn btn-sm btn-primary'
                            onClick={(e) => {
                              e.preventDefault()
                              e.stopPropagation()
                              e.nativeEvent.stopImmediatePropagation()

                              if (!isEditLink) {
                                linkForm.key = Math.floor(Math.random() * Date.now()).toString()
                              }
                              addNewLink(linkForm)
                              setLinkForm({
                                key: '',
                                description: '',
                                title: '',
                                url: '',
                              })
                            }}
                            // disabled={judol.button?.allowEdit === false}
                          >
                            {isEditLink ? 'Update Data' : 'Tambah Bukti Link'}
                          </button>
                        </div>
                        <hr />
                      </>
                    )}
                    <label className='form-section-title mt-5'>
                      <i className='fa-regular fa-file-lines'></i> List Link Web
                    </label>
                    <div className='row'>
                      <div className='col-md-12 mt-3'>
                        <table
                          id='kt_table_student'
                          className='table table-striped table-rounded dataTable align-middle table-row-dashed no-footer gs-7 fs-6 gy-5'
                        >
                          <thead>
                            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
                              <th>No</th>
                              <th>Judul</th>
                              <th>URL</th>
                              <th>Deskripsi</th>
                              {judol.button?.allowEdit && <th>Action</th>}
                            </tr>
                          </thead>
                          <tbody className='text-gray-600 fw-bold'>
                            {links.length > 0 ? (
                              links.map((row, i) => {
                                return (
                                  <tr key={i}>
                                    <td>{i + 1}</td>
                                    <td>{row.title ?? '-'}</td>
                                    <td>
                                      <a href={row.url} target='_blank'>{row.url ?? '-'}</a>
                                    </td>
                                    <td>{row.description ?? '-'}</td>
                                    {judol.button?.allowEdit && (
                                      <td>
                                        <div>
                                          {/* begin::Menu item */}
                                          <button
                                            type='button'
                                            className='btn menu-link text-primary px-3'
                                            onClick={() => {
                                              const item = links[i]
                                              setLinkForm(item)
                                              setEditLink(true)
                                            }}
                                            // disabled={judol.button?.allowEdit === false}
                                          >
                                            Edit
                                          </button>
                                          |
                                          <button
                                            type='button'
                                            className='btn menu-link text-primary px-3'
                                            data-kt-student-table-filter='delete_row'
                                            onClick={() => {
                                              setLink(links.filter((_, idx) => idx !== i))
                                              setLinkForm({
                                                description: '',
                                                id: 0,
                                                judolId: 0,
                                                key: '',
                                                title: '',
                                                url: '',
                                              })
                                            }}
                                            // disabled={judol.button?.allowEdit === false}
                                          >
                                            Delete
                                          </button>
                                        </div>
                                      </td>
                                    )}
                                  </tr>
                                )
                              })
                            ) : (
                              <tr>
                                <td colSpan={6}>
                                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                                    {isLoading ? '' : 'No matching records found'}
                                  </div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={`tab-pane ${tabActive === 4 && 'fade show active'}`}
                id='reporter'
                role='tabpanel'
                aria-labelledby='reporter-evidence'
              >
                <div className='tab-inner'>
                  <div className='container-fluid'>
                    <div>
                      <div className='row mb-2'>
                        <input type='hidden' value={reporterForm.key} />
                        <div className='col-md-6 mb-3'>
                          <label htmlFor='reporterName' className='form-label'>
                            Nama
                          </label>
                          <input
                            name='reporterName'
                            type='text'
                            id='pelapor'
                            className='form-control'
                            placeholder='Masukkan nama pelapor'
                            value={reporterForm.name}
                            onChange={(e) =>
                              setReporterForm({...reporterForm, name: e.target.value})
                            }
                            disabled={judol.button?.allowEdit === false}
                          />
                        </div>
                        <div className='col-md-6'>
                          <label htmlFor='reporterNik' className='form-label'>
                            NIK
                          </label>
                          <input
                            name='reporterNik'
                            type='text'
                            className='form-control'
                            placeholder='NIK'
                            maxLength={16}
                            value={reporterForm.nik}
                            onChange={(e) =>
                              setReporterForm({...reporterForm, nik: e.target.value})
                            }
                            disabled={judol.button?.allowEdit === false}
                          />
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-md-6 mb-3'>
                          <label htmlFor='reporterPob' className='form-label'>
                            Tempat Lahir
                          </label>
                          <input
                            type='text'
                            name='reporterPob'
                            className='form-control'
                            placeholder='Masukkan tempat lahir'
                            value={reporterForm.pob}
                            onChange={(e) =>
                              setReporterForm({...reporterForm, pob: e.target.value})
                            }
                            disabled={judol.button?.allowEdit === false}
                          />
                        </div>
                        <div className='col-md-6'>
                          <div className='fv-row d-flex flex-column mb-7'>
                            <label className='form-label' htmlFor='reporterDob'>
                              Tanggal Lahir
                            </label>
                            <input
                              type='date'
                              name='reporterDob'
                              className='form-control'
                              value={reporterForm.dob}
                              onChange={(e) =>
                                setReporterForm({...reporterForm, dob: e.target.value})
                              }
                              disabled={judol.button?.allowEdit === false}
                            />
                          </div>
                        </div>
                      </div>
                      {/* <div className='row mb-3'>
                        <div className='col-md-6'>
                          <label htmlFor='gender' className='form-label'>
                            Jenis Kelamin
                          </label>
                          <NoFormGenderSelect
                            value={reporterForm.gender ?? 0}
                            onChange={(e) => setReporterForm({...reporterForm, gender: e.value})}
                            disabled={judol.button?.allowEdit === false}
                          />
                        </div>
                      </div> */}
                      <div className='row'>
                        <div className='col-md-12'>
                          <label className='form-label' htmlFor='reporterAddress'>
                            Alamat
                          </label>
                          <textarea
                            rows={1}
                            name='reporterAddress'
                            className='form-control'
                            value={reporterForm.address}
                            onChange={(e) =>
                              setReporterForm({...reporterForm, address: e.target.value})
                            }
                            disabled={judol.button?.allowEdit === false}
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={`tab-pane ${tabActive === 5 && 'fade show active'}`}
                id='suspect'
                role='tabpanel'
                aria-labelledby='suspect'
              >
                <div className='tab-inner'>
                  <ReportSuspect
                    useAccordion={false}
                    handleCheckboxChange={handleCheckboxChange}
                    isEditSuspect={isEditSuspect}
                    isLoading={isLoading}
                    isTerlaporTersangka={isTerlaporTersangka}
                    setEditSuspect={setEditSuspect}
                    setSuspect={setSuspect}
                    suspects={suspects}
                    disabled={judol.button?.allowEdit === false}
                    useCheckbox={false}
                    resetValidation={tabActive === 5}
                  />
                </div>
              </div>
            </div>

            {isNotEmpty(judol.id) && (
              <>
                {/* <Accordion className='mb-3'>
                  <Accordion.Item eventKey='0'>
                    <Accordion.Header>Data Pelapor</Accordion.Header>
                    <Accordion.Body>
                      <div className='row mb-2'>
                        <input type='hidden' value={reporterForm.key} />
                        <div className='col-md-6 mb-3'>
                          <label htmlFor='reporterName' className='form-label'>
                            Nama
                          </label>
                          <input
                            name='reporterName'
                            type='text'
                            id='pelapor'
                            className='form-control'
                            placeholder='Masukkan nama pelapor'
                            value={reporterForm.name}
                            onChange={(e) =>
                              setReporterForm({...reporterForm, name: e.target.value})
                            }
                            disabled={judol.button?.allowEdit === false}
                          />
                        </div>
                        <div className='col-md-6'>
                          <label htmlFor='reporterNik' className='form-label'>
                            NIK
                          </label>
                          <input
                            name='reporterNik'
                            type='text'
                            className='form-control'
                            placeholder='NIK'
                            value={reporterForm.nik}
                            onChange={(e) =>
                              setReporterForm({...reporterForm, nik: e.target.value})
                            }
                            disabled={judol.button?.allowEdit === false}
                          />
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-md-6 mb-3'>
                          <label htmlFor='reporterPob' className='form-label'>
                            Tempat Lahir
                          </label>
                          <input
                            type='text'
                            name='reporterPob'
                            className='form-control'
                            placeholder='Masukkan tempat lahir'
                            value={reporterForm.pob}
                            onChange={(e) =>
                              setReporterForm({...reporterForm, pob: e.target.value})
                            }
                            disabled={judol.button?.allowEdit === false}
                          />
                        </div>
                        <div className='col-md-6'>
                          <div className='fv-row d-flex flex-column mb-7'>
                            <label className='fs-6 mb-2' htmlFor='reporterDob'>
                              Tanggal Lahir
                            </label>
                            <input
                              type='date'
                              name='reporterDob'
                              className='form-control'
                              value={reporterForm.dob}
                              onChange={(e) =>
                                setReporterForm({...reporterForm, dob: e.target.value})
                              }
                              disabled={judol.button?.allowEdit === false}
                            />
                          </div>
                        </div>
                      </div>
                      <div className='row mb-3'>
                        <div className='col-md-6'>
                          <label htmlFor='gender' className='form-label'>
                            Jenis Kelamin
                          </label>
                          <NoFormGenderSelect
                            value={reporterForm.gender ?? 0}
                            onChange={(e) => setReporterForm({...reporterForm, gender: e.value})}
                            disabled={judol.button?.allowEdit === false}
                          />
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-md-12'>
                          <label className='fs-6 mb-2' htmlFor='reporterAddress'>
                            Alamat
                          </label>
                          <textarea
                            rows={1}
                            name='reporterAddress'
                            className='form-control'
                            value={reporterForm.address}
                            onChange={(e) =>
                              setReporterForm({...reporterForm, address: e.target.value})
                            }
                            disabled={judol.button?.allowEdit === false}
                          ></textarea>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion> */}

                {/* <ReportReported
                  isEditReported={isEditReported}
                  isLoading={isLoading}
                  reported={reported}
                  setEditReported={setEditReported}
                  setReported={setReported}
                  disabled={judol.button?.allowEdit === false}
                /> */}

                {/* <Accordion className='mb-3'>
                  <Accordion.Item eventKey='0'>
                    <Accordion.Header>Data Tersangka</Accordion.Header>
                    <Accordion.Body>
                      <div className='row mb-2'>
                        <div className='col-md-6 mb-3'>
                          <input type='hidden' value={suspectForm.id ?? undefined} />
                          <label htmlFor='suspectName' className='form-label required'>
                            Nama
                          </label>
                          <input
                            type='text'
                            name='suspectName'
                            className='form-control'
                            placeholder='Masukkan nama tersangka'
                            value={suspectForm.name}
                            onChange={(e) => setSuspectForm({...suspectForm, name: e.target.value})}
                          />
                        </div>
                        <div className='col-md-6'>
                          <label htmlFor='suspectNik' className='form-label'>
                            NIK
                          </label>
                          <input
                            type='text'
                            className='form-control'
                            name='suspectNik'
                            placeholder='NIK'
                            value={suspectForm.nik}
                            onChange={(e) => setSuspectForm({...suspectForm, nik: e.target.value})}
                          />
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-md-6 mb-3'>
                          <label htmlFor='suspectPob' className='form-label'>
                            Tempat Lahir
                          </label>
                          <input
                            type='text'
                            name='suspectPob'
                            className='form-control'
                            placeholder='Masukkan tempat lahir'
                            value={suspectForm.pob}
                            onChange={(e) => setSuspectForm({...suspectForm, pob: e.target.value})}
                          />
                        </div>
                        <div className='col-md-6'>
                          <div className='fv-row d-flex flex-column mb-7'>
                            <label className='fs-6 mb-2' htmlFor='suspectDob'>
                              Tanggal Lahir
                            </label>
                            <input
                              type='date'
                              className='form-control'
                              name='suspectDob'
                              value={suspectForm.dob}
                              onChange={(e) =>
                                setSuspectForm({...suspectForm, dob: e.target.value})
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-md-12'>
                          <label className='fs-6 mb-2' htmlFor='suspectAddress'>
                            Alamat
                          </label>
                          <textarea
                            rows={1}
                            className='form-control'
                            name='suspectAddress'
                            value={suspectForm.address}
                            onChange={(e) =>
                              setSuspectForm({...suspectForm, address: e.target.value})
                            }
                          ></textarea>
                        </div>
                      </div>
                      <button
                        className='w-100 mt-3 btn btn-sm btn-primary'
                        onClick={(e) => {
                          e.preventDefault()
                          e.stopPropagation()
                          e.nativeEvent.stopImmediatePropagation()

                          if (!isEditSuspect) {
                            suspectForm.key = Math.floor(Math.random() * Date.now()).toString()
                          }
                          addNewSuspect(suspectForm)
                          setSuspectForm({
                            address: '',
                            dob: '',
                            gender: 0,
                            name: '',
                            nik: '',
                            pob: '',
                            key: '',
                          })
                        }}
                      >
                        Tambah Tersangka
                      </button>
                      <div className='row'>
                        <div className='col-md-12 mt-3'>
                          <table
                            id='kt_table_student'
                            className='table table-striped table-rounded dataTable align-middle table-row-dashed no-footer gs-7 fs-6 gy-5'
                          >
                            <thead>
                              <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
                                <th>No</th>
                                <th>Nama</th>
                                <th>NIK</th>
                                <th>Tempat Lahir</th>
                                <th>Tanggal Lahir</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody className='text-gray-600 fw-bold'>
                              {suspects.length > 0 ? (
                                suspects.map((row, i) => {
                                  return (
                                    <tr key={i}>
                                      <td>{i + 1}</td>
                                      <td>{row.name ?? '-'}</td>
                                      <td>{row.nik ?? '-'}</td>
                                      <td>{row.pob ?? '-'}</td>
                                      <td>{row.dob ?? '-'}</td>
                                      <td>
                                        {
                                          <div>
                                            <a
                                              role='button'
                                              className='menu-link px-3'
                                              onClick={() => {
                                                const item = suspects[i]
                                                setSuspectForm(item)
                                                setEditSuspect(true)
                                              }}
                                            >
                                              Edit
                                            </a>
                                            |
                                            <a
                                              role='button'
                                              className='menu-link px-3'
                                              data-kt-student-table-filter='delete_row'
                                              onClick={() => {
                                                setSuspect(suspects.filter((_, idx) => idx !== i))
                                                setSuspectForm({
                                                  address: '',
                                                  dob: '',
                                                  gender: 0,
                                                  key: '',
                                                  name: '',
                                                  nik: '',
                                                  pob: '',
                                                })
                                              }}
                                            >
                                              Delete
                                            </a>
                                          </div>
                                        }
                                      </td>
                                    </tr>
                                  )
                                })
                              ) : (
                                <tr>
                                  <td colSpan={6}>
                                    <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                                      {isLoading ? '' : 'No matching records found'}
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion> */}

                {/*<ReportAmplificationForm*/}
                {/*  reportId={judol.reportId ?? 0}*/}
                {/*  amplifications={amplifications}*/}
                {/*  setAmplifications={setAmplifications}*/}
                {/*  isLoading={isLoading}*/}
                {/*  disabled={judol.button?.allowEdit === false}*/}
                {/*></ReportAmplificationForm>*/}

                {/* <Accordion className='mb-3'>
                  <Accordion.Item eventKey='0'>
                    <Accordion.Header>Link Web</Accordion.Header>
                    <Accordion.Body>
                      <div className='row mb-2'>
                        <div className='col-md-6 mb-3'>
                          <input type='hidden' value={linkForm.id} />
                          <label htmlFor='report_evidence' className='form-label required'>
                            Judul
                          </label>
                          <input
                            type='text'
                            id='title-judol'
                            className='form-control'
                            placeholder='Masukkan Judul'
                            value={linkForm.title}
                            onChange={(e) => setLinkForm({...linkForm, title: e.target.value})}
                            disabled={judol.button?.allowEdit === false}
                          />
                        </div>
                        <div className='col-md-6'>
                          <label htmlFor='satuan' className='form-label'>
                            URL
                          </label>
                          <input
                            type='text'
                            className='form-control'
                            placeholder='Masukkan URL'
                            value={linkForm.url}
                            onChange={(e) => setLinkForm({...linkForm, url: e.target.value})}
                            disabled={judol.button?.allowEdit === false}
                          />
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-md-12'>
                          <label className='fs-6 mb-2'>Deskripsi</label>
                          <textarea
                            rows={3}
                            className='form-control'
                            value={linkForm.description}
                            onChange={(e) =>
                              setLinkForm({...linkForm, description: e.target.value})
                            }
                            disabled={judol.button?.allowEdit === false}
                          ></textarea>
                        </div>
                      </div>
                      <button
                        className='w-100 mt-3 btn btn-sm btn-primary'
                        onClick={(e) => {
                          e.preventDefault()
                          e.stopPropagation()
                          e.nativeEvent.stopImmediatePropagation()

                          if (!isEditLink) {
                            linkForm.key = Math.floor(Math.random() * Date.now()).toString()
                          }
                          addNewLink(linkForm)
                          setLinkForm({
                            key: '',
                            description: '',
                            title: '',
                            url: '',
                          })
                        }}
                        disabled={judol.button?.allowEdit === false}
                      >
                        Tambah Bukti Link
                      </button>
                      <div className='row'>
                        <div className='col-md-12 mt-3'>
                          <table
                            id='kt_table_student'
                            className='table table-striped table-rounded dataTable align-middle table-row-dashed no-footer gs-7 fs-6 gy-5'
                          >
                            <thead>
                              <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
                                <th>No</th>
                                <th>Judul</th>
                                <th>URL</th>
                                <th>Deskripsi</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody className='text-gray-600 fw-bold'>
                              {links.length > 0 ? (
                                links.map((row, i) => {
                                  return (
                                    <tr key={i}>
                                      <td>{i + 1}</td>
                                      <td>{row.title ?? '-'}</td>
                                      <td>{row.url ?? '-'}</td>
                                      <td>{row.description ?? '-'}</td>
                                      <td>
                                        {
                                          <div>
                                            <button
                                              type='button'
                                              className='btn menu-link text-primary px-3'
                                              onClick={() => {
                                                const item = links[i]
                                                setLinkForm(item)
                                                setEditLink(true)
                                              }}
                                              disabled={judol.button?.allowEdit === false}
                                            >
                                              Edit
                                            </button>
                                            |
                                            <button
                                              type='button'
                                              className='btn menu-link text-primary px-3'
                                              data-kt-student-table-filter='delete_row'
                                              onClick={() => {
                                                setLink(links.filter((_, idx) => idx !== i))
                                                setLinkForm({
                                                  description: '',
                                                  id: 0,
                                                  judolId: 0,
                                                  key: '',
                                                  title: '',
                                                  url: '',
                                                })
                                              }}
                                              disabled={judol.button?.allowEdit === false}
                                            >
                                              Delete
                                            </button>
                                          </div>
                                        }
                                      </td>
                                    </tr>
                                  )
                                })
                              ) : (
                                <tr>
                                  <td colSpan={6}>
                                    <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                                      {isLoading ? '' : 'No matching records found'}
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion> */}
              </>
            )}
          </div>

          {/* Submit Button */}
          <div className='row g-2'>
            {(judol.button?.allowSubmit === true || !isNotEmpty(judol.id)) && (
              <div className='d-flex justify-content-between'>
                {' '}
                {tabActive > 0 && tabActive < tabs.length ? (
                  <button
                    type='button'
                    onClick={() => saveDraft(false)}
                    className='btn btn-secondary btn-active-light-primary me-3'
                  >
                    Kembali
                  </button>
                ) : (
                  <div></div>
                )}
                <div>
                  <button
                    type='button'
                    onClick={() => saveDraft(true)}
                    className='btn btn-outline btn-outline-primary btn-active-light-primary'
                  >
                    {tabActive === tabs.length - 1 ? 'Simpan' : 'Lanjutkan'}
                  </button>

                  {isNotEmpty(judol.id) && (
                    <button type='submit' className='btn btn-primary ms-3'>
                      Submit Laporan
                    </button>
                  )}
                </div>
              </div>
            )}

            {judol.button?.allowReject && (
              <div className='col-md-6'>
                <button
                  type='button'
                  onClick={handleOpenRejectConfirmation}
                  className='btn btn-outline btn-outline-danger btn-danger w-100'
                >
                  Tolak
                </button>
              </div>
            )}

            {judol.button?.allowVerif && (
              <div className='col-md-6'>
                <button
                  type='button'
                  onClick={handleOpenVerifyConfirmation}
                  className='btn btn-success w-100'
                >
                  Verifikasi
                </button>
              </div>
            )}
          </div>
        {/*</fieldset>*/}
      </form>
      {(formik.isSubmitting || isLoading) && <JudolListLoading />}

      <Confirm
        show={showVerifyConfirmation}
        handleClose={handleCloseVerifyConfirmation}
        handleConfirm={handleConfirmVerify}
        name={`Verifikasi ${judol.policeReportNo}`}
        body={`Apakah anda yakin ingin memverifikasi ${judol.policeReportNo}?`}
        isLoading={formik.isSubmitting || isLoading}
      />
      <Confirm
        show={showRejectConfirmation}
        handleClose={handleCloseRejectConfirmation}
        handleConfirm={handleConfirmReject}
        name={`Tolak ${judol.policeReportNo}`}
        body={`Apakah anda yakin ingin menolak ${judol.policeReportNo}?`}
        isLoading={isLoading}
      />
    </>
  )
}

export {JudolEditModalForm}
